import axios from "axios";

const search = payload => {
  const params = new URLSearchParams();
  Object.keys(payload).forEach(key => {
    if (payload[key] !== "") {
      params.set(
        `${key.replace(/([A-Z])/g, "_$1").toLowerCase()}`,
        payload[key]
      );
    }
  });

  return axios.get(`/api/v1/npi_data/search?${params}`);
};

const show = npi => axios.get(`/api/v1/npi_data/${npi}`);

const npiApi = {
  show,
  search,
};

export default npiApi;
